import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IBulkQuantitySummaryRow, IBulkQuantityModalConfig } from '@core/interfaces';

/**
 * Generic modal asking for a quantity, bounded by a maximum.
 * It closes with `{ quantity }` on confirmation and is dismissed on cancel.
 */
@Component({
  selector: 'app-bulk-quantity-modal',
  templateUrl: './bulk-quantity-modal.component.html',
})
export class BulkQuantityModalComponent implements OnInit, IBulkQuantityModalConfig {

  @Input() public title: string = 'Ajout par lot';
  @Input() public titleIcon: string = 'fa-layer-group';
  @Input() public subtitle: string | undefined;
  @Input() public quantityLabel: string = 'Quantité à ajouter';
  @Input() public maxQuantity: number = 1;
  @Input() public summaryRows: IBulkQuantitySummaryRow[] = [];
  @Input() public confirmLabel: string = 'Valider';
  @Input() public confirmButtonClass: string = 'btn-primary';
  @Input() public cancelLabel: string = 'Annuler';

  public formGroup: FormGroup<{ quantity: FormControl<number | null> }>;

  constructor(public modal: NgbActiveModal) {}

  public ngOnInit(): void {
    this.formGroup = new FormGroup({
      quantity: new FormControl<number | null>(null, [
        Validators.required,
        Validators.min(1),
        Validators.max(this.maxQuantity),
        Validators.pattern(/^\d+$/),
      ]),
    });
  }

  public confirm(): void {
    if (this.formGroup.invalid) {
      return;
    }
    this.modal.close({ quantity: this.formGroup.value.quantity });
  }
}
